module.exports = __webpack_public_path__ + "img/mine1.9f5c608c.png";